module.exports = __webpack_public_path__ + "img/personalZh.6cf32a5b.jpg";